import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  LOCALE_ID,
  importProvidersFrom,
  // isDevMode,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { httpInterceptor } from './interceptor-http.service';
// import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideStore } from '@ngrx/store';
import { provideRouterStore } from '@ngrx/router-store';
import { provideEffects } from '@ngrx/effects';

import { provideGoogleService } from '@ls-commons/auth';
import { provideMarkdown } from 'ngx-markdown';
import { utilsCacheInterceptor } from '@ls-commons/utils/interceptors';
import { environment } from '../environments/environment';
import { MessageService } from 'primeng/api';
import { ComponentsConfigModule } from '@ls-commons/components/config';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { ChunkErrorHandler } from './services/app-update/chunk-error.handler';
import {
  APP_UPDATE_EXCLUDED,
  AppUpdateService,
} from './services/app-update/app-update.service';

registerLocaleData(localeEs, 'es');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeDe, 'de');

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(ComponentsConfigModule, DynamicDialogModule),
    DialogService,
    provideMarkdown(),
    MessageService,
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
      })
    ),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([httpInterceptor(), utilsCacheInterceptor()])
    ),
    provideStore(),
    provideEffects(),
    provideRouterStore(),
    provideGoogleService(environment.GOOGLE_ID),
    // provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    {
      provide: LOCALE_ID,
      useValue: document.documentElement.lang,
    },
    // Aviso de versión nueva tras un deploy (TS569)
    { provide: ErrorHandler, useClass: ChunkErrorHandler },
    {
      // En la vuelta del pago no se ofrece recargar: el aviso espera a que salga
      provide: APP_UPDATE_EXCLUDED,
      useValue: (url: string) => /^\/redsys-notify(\/|$)/.test(url),
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AppUpdateService],
      useFactory: (appUpdate: AppUpdateService) => () => appUpdate.start(),
    },
  ],
};
